import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import { SCREEN_ID_UTILITY_SETUP_OVERVIEW } from 'client/constants/screenIds';

import { SR_API_ACTION_UTILITY_ACTIVATION_GET } from 'api/utilityActionTypes';

import { hasRoleAdmin, hasRolePartner, hasRoleRenter } from 'common/utility/userRoles';

import withApiState from 'client/helpers/withApiState';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';
import withLocationQuery from 'client/helpers/withLocationQuery';

import branch from 'client/core/branch';

@withTransitionHook
@withScreenId(SCREEN_ID_UTILITY_SETUP_OVERVIEW)
@withScrollToTop
@withLocationQuery
@branch({
  utilityUser: ['utilityUser'],
})
@branch(({ utilityUser }) => {
  if (hasRoleRenter(utilityUser.roles)) {
    return {
      userUtilityActivation: ['utilityActivations', 'byUtilityUserId', utilityUser.id],
    };
  }
  return {};
})
@withApiState({
  utilityActivationApiState: {
    action: SR_API_ACTION_UTILITY_ACTIVATION_GET,
  },
})
class UtilitySetupRedirectPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Utility Setup | Overview',
  });

  render() {
    const {
      userUtilityActivation,
      utilityActivationApiState,
      locationQuery,
      utilityUser,
    } = this.props;

    if (userUtilityActivation) {
      return (
        <Redirect
          to={`/utility-setup/${userUtilityActivation.partner.slug}/${userUtilityActivation.shortId}`}
        />
      );
    }

    if (utilityActivationApiState.inProgress) {
      return <div className="loading-ellipses" />;
    }

    if (locationQuery.partner) {
      return <Redirect to={`/utility-setup/${locationQuery.partner}`} />;
    }

    if (hasRoleAdmin(utilityUser.roles)) {
      return <Redirect to="/utility-profit/admin" />;
    }

    if (hasRolePartner(utilityUser.roles)) {
      return <Redirect to="/utility-profit" />;
    }

    return <div className="loading-ellipses" />;
  }
}

UtilitySetupRedirectPage.displayName = 'UtilitySetupRedirectPage';

export default UtilitySetupRedirectPage;
